// src/components/ZiloLockGate.js
//
// Wraps the 4 Zilo pages (Dashboard, Clients, Reviews, Campaigns) — shows a
// "pending approval" screen instead of the real page when someone has just
// paid for Zilo access (standalone or via a bundle) but an admin hasn't
// unlocked it yet. ziloUnlocked === false is the only locked state;
// undefined/true both mean "go ahead" (covers existing customers from
// before this gate existed).
import React from "react";
import { useAuth } from "../context/AuthContext";
import { Card } from "./UI";
import { Sparkles } from "lucide-react";

export default function ZiloLockGate({ children }) {
  const { businessProfile } = useAuth();
  if (businessProfile?.ziloUnlocked !== false) return children;

  return (
    <div className="rb-page" style={{ padding: "36px 40px", maxWidth: 700, animation: "fadeIn .4s ease" }}>
      <Card style={{ padding: "40px 32px", textAlign: "center", borderStyle: "dashed" }}>
        <div style={{ width: 48, height: 48, borderRadius: "50%", background: "var(--amber-lt)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
          <Sparkles size={20} color="var(--amber)" />
        </div>
        <h2 style={{ fontSize: 16, fontWeight: 700, marginBottom: 6 }}>Thanks for your purchase!</h2>
        <p style={{ fontSize: 13, color: "var(--text-3)", maxWidth: 420, margin: "0 auto" }}>
          Your TechBugz team is reviewing your account and will unlock Zilo shortly.
        </p>
      </Card>
    </div>
  );
}
